import { render } from "./teach-desc.vue?vue&type=template&id=7586412e&scoped=true"
import script from "./teach-desc.vue?vue&type=script&lang=js"
export * from "./teach-desc.vue?vue&type=script&lang=js"

import "./teach-desc.vue?vue&type=style&index=0&id=7586412e&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7586412e"]])

export default __exports__